var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 0.666748H3.33317L5.11984 9.59342C5.1808 9.90035 5.34778 10.1761 5.59153 10.3723C5.83529 10.5685 6.1403 10.6727 6.45317 10.6667H12.9332C13.246 10.6727 13.551 10.5685 13.7948 10.3723C14.0386 10.1761 14.2055 9.90035 14.2665 9.59342L15.3332 4.00008H3.99984M6.6665 14.0001C6.6665 14.3683 6.36803 14.6667 5.99984 14.6667C5.63165 14.6667 5.33317 14.3683 5.33317 14.0001C5.33317 13.6319 5.63165 13.3334 5.99984 13.3334C6.36803 13.3334 6.6665 13.6319 6.6665 14.0001ZM13.9998 14.0001C13.9998 14.3683 13.7014 14.6667 13.3332 14.6667C12.965 14.6667 12.6665 14.3683 12.6665 14.0001C12.6665 13.6319 12.965 13.3334 13.3332 13.3334C13.7014 13.3334 13.9998 13.6319 13.9998 14.0001Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.09c1c4a3de081649c3e7dbb8cc21e3cd.svg";
export { ForwardRef as ReactComponent };